/*
 *  I07CALCPUISSRADCalcul.js
 *
 *  Created by Sébastien Hecart on 2017-12-10 19:37:20 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

import { fetchTypeRadiateur, fetchRegimeDimensionnement } from '@batical/data/src'
import { RRegimeDimensionnementSchema_Type, RTypeRadiateurSchema_Type, I07CALCPUISSRAD_State } from '@batical/types/src'
import { chain } from 'mathjs'
function I07CALCPUISSRAD_docalcul(state: I07CALCPUISSRAD_State) {
  state.invalidated = false
  let selectedtypeRadiateur_uuid: RTypeRadiateurSchema_Type = fetchTypeRadiateur(state.typeRadiateur_uuid)
  //this case could not happen, fetch type radiateur always return a value
  // if (state.in_acierFonteIndex !== 1 && !selectedtypeRadiateur_uuid) {
  //   //type is required if not foonte
  //   state.res_puissanceNominale = 0
  //   return state
  // }
  let selectedregimeDimensionnemnt_uuid: RRegimeDimensionnementSchema_Type = fetchRegimeDimensionnement(state.regimeDimensionnemnt_uuid)

  if (state.in_acierFonteIndex === 2 && selectedtypeRadiateur_uuid) {
    state.in_longeurRadiateur = state.in_nombreElement * selectedtypeRadiateur_uuid.largeur

    state.res_puissanceNominale =
      selectedtypeRadiateur_uuid.coeffkm *
      Math.pow(selectedregimeDimensionnemnt_uuid.temperature_moyenne - state.in_tempConsInt, selectedtypeRadiateur_uuid.expn) *
      state.in_nombreElement
    return state
  }

  var pouvoirEmissifRadiateur: number = 0

  if (state.in_acierFonteIndex === 0 && selectedtypeRadiateur_uuid) {
    pouvoirEmissifRadiateur = (selectedtypeRadiateur_uuid.factor * state.in_hauteurRadiateur) / 10 + selectedtypeRadiateur_uuid.add
  } else {
    if (state.in_profondeurRadiateur === 0) {
      state.res_puissanceNominale = 0
      return state
    }
    pouvoirEmissifRadiateur = ((-2.3286 * state.in_hauteurRadiateur) / 10 + 1918.9) * Math.exp((0.0384 * state.in_profondeurRadiateur) / 10)
  }
  const coeffReduction = Math.pow(
    (selectedregimeDimensionnemnt_uuid.temperature_moyenne - state.in_tempConsInt) / (80 - state.in_tempConsInt),
    1.3
  )
  state.res_puissanceNominale = chain(pouvoirEmissifRadiateur)
    .multiply(coeffReduction)
    .multiply(state.in_hauteurRadiateur)
    .divide(1000)
    .multiply(state.in_longeurRadiateur)
    .divide(1000)
    .done()

  return state
}

export default I07CALCPUISSRAD_docalcul
